import type Owner from '@ember/owner';
import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import GoalsBaseComponent, { type GoalsBaseArgs } from 'webapp/components/goals/base';

import type { DeleteAction } from 'webapp/models-custom/batch-select';
import BatchSelect from 'webapp/models-custom/batch-select';
import type FilterSortGoalInGrid from 'webapp/models-custom/filter-sort/goal-company-in-grid';
import type FilterSortGoalInList from 'webapp/models-custom/filter-sort/goal-company-in-list';
import type Goal from 'webapp/models-custom/goal';

export interface GoalsCompanyArgs extends GoalsBaseArgs {
	onAdd: () => void;
}

export default abstract class GoalsCompanyBaseComponent extends GoalsBaseComponent<GoalsCompanyArgs> {
	@service('store') declare storeService: Service.Store;

	abstract filterSort: FilterSortGoalInGrid | FilterSortGoalInList;

	batchSelect: BatchSelect<Goal>;

	constructor(owner: Owner, args: GoalsCompanyArgs) {
		super(owner, args);

		this.batchSelect = new BatchSelect<Goal>({
			getAllItems: () => {
				return this.filterSort.results;
			},
			getOptions: () => {
				return this.batchOptions;
			},
			doBatchAction: (actionName) => {
				return this.doBatchAction(actionName as DeleteAction);
			},
		});
	}

	get hasFavoriteGoals(): boolean {
		return this.model.filter((item) => item.favorite).length > 0;
	}

	@cached
	get isFavoriteSectionVisible(): boolean {
		return this.favoriteGoalsFilterFn(this.filterSort.results).length > 0;
	}
}
